import { render, staticRenderFns } from "./ItoviImageUpload.vue?vue&type=template&id=a4d539c6&scoped=true&"
import script from "./ItoviImageUpload.vue?vue&type=script&lang=js&"
export * from "./ItoviImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ItoviImageUpload.vue?vue&type=style&index=0&id=a4d539c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d539c6",
  null
  
)

export default component.exports